import React from "react";
import Table from "semantic-ui-react/dist/commonjs/collections/Table";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";

import masterData from "../../lib/masterData";
import classnames from "classnames";
import { modal } from "../../common/modal";
import { applyRoom, contactForRoom } from "../area/util";
import { openContactSelector } from "../../common/callUtil"
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import api from "../../lib/api";
import { searchRoom } from "../../lib/masterUtil";
import moment from "moment";
import roomListImplCard from "./roomListImplCard"
import roomListImplTable from "./roomListImplTable"

export class RoomList extends React.Component {
  state = {
    condition: {
      // vacant: true,
    },
    sortType: 0,
  };
  constructor(props) {
    super(props);
    this.sort = {
      type: "roomNo",
      ascending: 1,
    };
  }
  selectFloor(floor) {
    this.setState({ floor });
  }
  openMadori(room) {
    modal.openModal("modal_madori", {
      room,
      asset: this.props.asset,
      floorId: room.floor,
    });
  }
  updateCondition(condition) {
    this.setState(state => {
      return Object.assign({}, state, {
        condition: Object.assign({}, state.condition, condition),
      });
    });
  }
  updateSort(sortType) {
    const roomSortOrder = masterData.roomSortOrder.byValue[sortType];
    const sortParams = roomSortOrder && roomSortOrder.params;
    this.setState({ sortType, sortParams });
  }
  toggleSort(newSortKey) {
    const { sortDirection, sortKey } = this.state.sortParams || {};
    // const newSortDirection = newSortKey === sortKey ? sortDirection * -1 : 1;
    let newSortDirection = 1;
    if (newSortKey === sortKey) {
      if (sortDirection === 1) {
        newSortDirection = -1;
      } else if (sortDirection === -1) {
        this.setState({ sortParams: null });
        return;
      } else {
        newSortDirection = 1;
      }
    }
    this.setState({ sortParams: { sortDirection: newSortDirection, sortKey: newSortKey } });
  }
  toggleAki = (akiVisible, index) => {
    if (index == 1) {
      this.setState({ aki1Visible: !akiVisible });
    } else if (index == 2) {
      this.setState({ aki2Visible: !akiVisible });
    } else if (index == 3) {
      this.setState({ aki3Visible: !akiVisible });
    } else if (index == 4) {
      this.setState({ aki4Visible: !akiVisible });
    } else if (index == 11) {
      this.setState({ akiContainer1Visible: !akiVisible });
    } else if (index == 12) {
      this.setState({ akiContainer2Visible: !akiVisible });
    } else if (index == 13) {
      this.setState({ akiContainer3Visible: !akiVisible });
    } else if (index == 14) {
      this.setState({ akiContainer4Visible: !akiVisible });
    } else if (index == 15) {
      this.setState({ akiContainer5Visible: !akiVisible });
    } else if (index == 16) {
      this.setState({ akiContainer6Visible: !akiVisible });
    } else if (index == 17) {
      this.setState({ akiContainer7Visible: !akiVisible });
    } else if (index == 18) {
      this.setState({ akiContainer8Visible: !akiVisible });
    } else if (index == 19) {
      this.setState({ akiContainer9Visible: !akiVisible });
    } else if (index == 20) {
      this.setState({ akiContainer10Visible: !akiVisible });
    }
  };
  toggleAki1 = aki1Visible => {
    this.setState({ aki1Visible: !aki1Visible });
  };
  toggleAki2 = aki2Visible => {
    this.setState({ aki2Visible: !aki2Visible });
  };
  toggleAki3 = aki3Visible => {
    this.setState({ aki3Visible: !aki3Visible });
  };
  toggleAki4 = aki4Visible => {
    this.setState({ aki4Visible: !aki4Visible });
  };
  toggleAkiContainer1 = akiContainer1Visible => {
    this.setState({ aki1ContainerVisible: !akiContainer1Visible });
  };
  toggleAkiContainer2 = akiContainer2Visible => {
    this.setState({ aki2ContainerVisible: !akiContainer2Visible });
  };
  toggleAkiContainer3 = akiContainer3Visible => {
    this.setState({ aki3ContainerVisible: !akiContainer3Visible });
  };
  toggleAkiContainer4 = akiContainer4Visible => {
    this.setState({ aki4ContainerVisible: !akiContainer4Visible });
  };
  toggleAkiContainer5 = akiContainer5Visible => {
    this.setState({ aki5ContainerVisible: !akiContainer5Visible });
  };
  toggleAkiContainer6 = akiContainer6Visible => {
    this.setState({ aki6ContainerVisible: !akiContainer6Visible });
  };
  toggleAkiContainer7 = akiContainer7Visible => {
    this.setState({ aki7ContainerVisible: !akiContainer7Visible });
  };
  toggleAkiContainer8 = akiContainer8Visible => {
    this.setState({ aki8ContainerVisible: !akiContainer8Visible });
  };
  toggleAkiContainer9 = akiContainer9Visible => {
    this.setState({ aki9ContainerVisible: !akiContainer9Visible });
  };
  toggleAkiContainer10 = akiContainer10Visible => {
    this.setState({ aki10ContainerVisible: !akiContainer10Visible });
  };
  toggleElse = elseVisible => {
    this.setState({ elseVisible: !elseVisible });
  };
  getSortIcon(targetSortKey) {
    const { sortDirection, sortKey } = this.state.sortParams || {};
    if (sortKey === targetSortKey) {
      if (sortDirection === 1) {
        return "fa fa-sort-down";
      } else if (sortDirection === -1) {
        return "fa fa-sort-up";
      }
    }
    return "fa fa-sort";
  }
  getVideoUrl(extent){
    if (extent <= 0.5) return {videoUrl: 'resource/video/0.5.mp4'};
    if (extent <= 1) return {videoUrl: 'resource/video/1.mp4'};
    if (extent <= 2) return {videoUrl: 'resource/video/2.mp4'};
    if (extent <= 4) return {videoUrl: 'resource/video/4.mp4'};
    if (extent >= 7 && extent <= 9) return {videoUrl: 'resource/video/8.mp4'};
    return {};
  }
  goToCampaign() {
    const elementTop = document.getElementById('campaign_detail').offsetTop;
    const fixedHeaderHeight = document.querySelector(".header .flexed_helper").offsetHeight
    window.scroll({
      top: elementTop - fixedHeaderHeight,
      behavior: "smooth",
    });
  }
  getAddDate(dateNum) {
    let dt = new Date();
    dt.setDate(dt.getDate() + dateNum);
    let month = String((dt.getMonth() + 1));
    if (month.length === 1) {
      month = "0" + (dt.getMonth() + 1);
    }
    return String(dt.getFullYear()) + "-" + month + "-" + String(dt.getDate());
  }
  render() {
    const { asset, type } = this.props;
    const rooms = searchRoom(
      asset.rooms,
      Object.assign({}, this.state.condition, {
        floor: this.state.floor,
      }),
      this.state.sortParams
    );

    const rooms1 = asset.rooms && asset.rooms.length > 0 && asset.rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE);
    const roomsElseCanReserve = asset.rooms && asset.rooms.length > 0 && asset.rooms.filter(x => x.vacant !== masterData.vacant.AVAILABLE &&
      ((x.riyouKikanEnd && x.riyouKikanEnd.replace(/-/g, "") > this.getAddDate(15).replace(/-/g, ""))));

    const isNoVacancy = (!rooms1 || rooms1.length === 0) && (!roomsElseCanReserve || roomsElseCanReserve.length === 0);
    console.log("rooms", this.state.condition, rooms);
    const pref = masterData.pref.byId[asset.pref];
    const prefSlug = (pref && pref.slug) || "";

    const searchParams = new URLSearchParams(this.props.location.search);
    const listType = searchParams.get("listType");

    if (type === TYPE_SP || listType === 'card') {
      return roomListImplCard.call(this, { rooms, prefSlug, asset, type, isNoVacancy })
    } else {
      return roomListImplTable.call(this, { rooms, prefSlug, asset, type, isNoVacancy })
    }
  }
}



// WEBPACK FOOTER //
// ./pages/detail/RoomList.jsx